module.exports = __webpack_public_path__ + "b43fccd6.svg";